<pg-header
  title="ULBs"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="ulbLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="(USER_PERMISSIONS.exprt_in==1)?true:false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.updt_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit',data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.dlte_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete',data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="mcrpckMrgn">
      <div class="inptLbl">ULB Name</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="ulbDt.ulbNm"
          placeholder="please enter ulb name"
        />
      </nz-input-wrapper>
    </div>
    <!-- <div class="inptLbl">ULB Api ID</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input type="text" nz-input [(ngModel)]="ulbDt.apiId" placeholder="please enter ulb api id" />
      </nz-input-wrapper>
      <div class="inptLbl">ULB Code</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input type="text" nz-input [(ngModel)]="ulbDt.cd" placeholder="please enter ulb code" />
      </nz-input-wrapper> -->
    <div class="mcrpckMrgn">
      <div class="inptLbl">Lat</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="ulbDt.lat"
          placeholder="please enter ulb lattitude"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">Lng</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="ulbDt.lng"
          placeholder="please enter ulb longitude"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">District</div>
      <input
        placeholder="Select District"
        nz-input
        [(ngModel)]="ulbDt.dstrct_nm"
        (ngModelChange)="onChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (d of filteredOptions; track d) {
        <nz-auto-option
          [nzValue]="d.dstrt_nm"
          (click)="getDstrtID(d.dstrt_id);"
        >
          {{d.dstrt_nm}}</nz-auto-option
        >
        }
      </nz-autocomplete>
    </div>
    <ng-template #inputClearTpl
      >@if (ulbDt.ulbNm) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="ulbDt = {}"
      ></i>
      }</ng-template
    >
    @if (shwULBEditDiv==false && shwULBDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveULB()">
      Submit
    </button>
    } @if (shwULBEditDiv==true && shwULBDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveEditULB()">
      Update
    </button>
    } @if (shwULBEditDiv==false && shwULBDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this ULB?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeleteULB()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
  <!-- </div>
  </div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
